var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCorporateCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28201_14878)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28201_14878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0293 10.625C25.4593 12.4625 26.2368 14.6475 26.3605 16.87H30.058C29.7655 13.6187 27.238 11.0188 24.0293 10.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1842 11.5781C22.018 13.1494 21.3792 14.9944 21.2617 16.8681H25.1067C24.9892 14.9944 24.3505 13.1494 23.1842 11.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3086 16.87H20.0061C20.1298 14.6475 20.9073 12.4625 22.3373 10.625C19.1286 11.0188 16.6011 13.6187 16.3086 16.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0579 18.1328H28.4629C28.6766 18.5003 28.8079 18.9216 28.8079 19.3766V21.5066C29.4954 20.5366 29.9454 19.3853 30.0579 18.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 23.125V28.125C10.0586 28.815 10.6198 29.375 11.3086 29.375H26.3086C26.9986 29.375 27.5586 28.815 27.5586 28.125V23.125H10.0586ZM15.6836 26.875H13.1836C12.8386 26.875 12.5586 26.595 12.5586 26.25C12.5586 25.905 12.8386 25.625 13.1836 25.625H15.6836C16.0286 25.625 16.3086 25.905 16.3086 26.25C16.3086 26.595 16.0286 26.875 15.6836 26.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3086 18.125H11.3086C10.6198 18.125 10.0586 18.6862 10.0586 19.375V20.625H27.5586V19.375C27.5586 18.6862 26.9986 18.125 26.3086 18.125Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28201_14878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28201_14878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10.0586 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCorporateCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_corporate_card.fe3f2fb872b31fabec3d43e1177fa3fd.svg";